"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.trafficReport = exports.dbQuery = exports.dbGranularity = exports.dbTableTraffic = exports.dbTableCampaign = exports.dbSchema = exports.modelTypes = exports.genericReport = exports.analyticsReport = exports.dateISOHelpers = void 0;
// model/reporterDb
// helpers
exports.dateISOHelpers = __importStar(require("./helpers/dateISO.js"));
// model/analyticsReport
__exportStar(require("./model/analyticsReport/index.js"), exports);
exports.analyticsReport = __importStar(require("./model/analyticsReport/index.js"));
// model/genericReport
__exportStar(require("./model/genericReport/index.js"), exports);
exports.genericReport = __importStar(require("./model/genericReport/index.js"));
// model/trafficReport
__exportStar(require("./model/inventoryReport/index.js"), exports);
// modelTypes
__exportStar(require("./model/modelTypes.js"), exports);
exports.modelTypes = __importStar(require("./model/modelTypes.js"));
__exportStar(require("./model/reporterDb/dbSchema.js"), exports);
exports.dbSchema = __importStar(require("./model/reporterDb/dbSchema.js"));
__exportStar(require("./model/reporterDb/dbTableCampaign/index.js"), exports);
exports.dbTableCampaign = __importStar(require("./model/reporterDb/dbTableCampaign/index.js"));
__exportStar(require("./model/reporterDb/dbTableTraffic/index.js"), exports);
exports.dbTableTraffic = __importStar(require("./model/reporterDb/dbTableTraffic/index.js"));
__exportStar(require("./model/reporterDb/granularity.js"), exports);
exports.dbGranularity = __importStar(require("./model/reporterDb/granularity.js"));
__exportStar(require("./model/reporterDb/query/index.js"), exports);
exports.dbQuery = __importStar(require("./model/reporterDb/query/index.js"));
// model/trafficReport
__exportStar(require("./model/trafficReport/index.js"), exports);
exports.trafficReport = __importStar(require("./model/trafficReport/index.js"));
